import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { getInitials } from '../../utils/formatters';
import {
  RxDashboard, RxCube, RxPerson, RxCalendar,
  RxBarChart, RxExit, RxReader, RxLayers, RxBell
} from 'react-icons/rx';

const ownerLinks = [
  { to: '/dashboard', label: 'Dashboard', icon: RxDashboard },
  { to: '/vehicles',  label: 'Vehicles',  icon: RxCube },
  { to: '/drivers',   label: 'Drivers',   icon: RxPerson },
  { to: '/trips',     label: 'Trips',     icon: RxLayers },
  { to: '/expenses',  label: 'Expenses',  icon: RxReader },
  { to: '/notifications', label: 'Notifications', icon: RxBell },
  { to: '/leaves',    label: 'Leaves',    icon: RxCalendar },
  { to: '/reports',   label: 'Reports',   icon: RxBarChart },
];

const driverLinks = [
  { to: '/dashboard', label: 'Dashboard', icon: RxDashboard },
  { to: '/trips',     label: 'Today Trips',  icon: RxLayers },
  { to: '/notifications', label: 'Notifications', icon: RxBell },
  { to: '/leaves',    label: 'Leaves',    icon: RxCalendar },
];

export default function Sidebar({ isOpen, onClose }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const links = user?.role === 'driver' ? driverLinks : ownerLinks;

  const handleLogout = () => { logout(); navigate('/sign-in'); };

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-logo">
        <div className="sidebar-logo-text">Mololine</div>
        <div className="sidebar-logo-sub">Fleet Management</div>
      </div>

      <nav className="sidebar-nav">
        <div className="sidebar-section-label">Menu</div>
        {links.map(({ to, label, icon: Icon }) => (
          <NavLink key={to} to={to} className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`} onClick={onClose}>
            <Icon /> {label}
          </NavLink>
        ))}
        <div style={{ margin: '0.5rem 0.5rem 0', height: '1px', background: 'rgba(255,255,255,0.1)' }} />
        <NavLink to="/profile" className={({ isActive }) => `sidebar-nav-item ${isActive ? 'active' : ''}`} onClick={onClose}>
          <RxPerson /> Profile
        </NavLink>
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">{getInitials(user?.full_name || user?.email || 'U')}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="sidebar-user-name" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user?.full_name || user?.email}
            </div>
            <div className="sidebar-user-role">{user?.role === 'driver' ? 'Driver' : 'Fleet Owner'}</div>
          </div>
          <button onClick={handleLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,0.5)', padding: '0.25rem' }}>
            <RxExit size={18} />
          </button>
        </div>
      </div>
    </aside>
  );
}